<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
* {
  box-sizing: border-box;
} 
html {
}
body{
}
body::before {
  content: "";
  background: url(assets/images/main-visual.jpg);
  background-size: auto 200vh;
  background-position: center;
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}   
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #231815;
}
</style>



// WEBPACK FOOTER //
// App.vue?47afb443